/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".show-mobile[_ngcontent-%COMP%]{display:none}@media screen and (max-width:0px){.show-mobile[_ngcontent-%COMP%]{display:block}}.sort[_ngcontent-%COMP%]{-webkit-text-decoration-line:underline;text-decoration-line:underline;cursor:pointer}.info-wrapper[_ngcontent-%COMP%]{border:1px solid #000;border-radius:.25rem;padding:5px;margin-top:5px;background:#fff;font-size:12px}"];
export { styles as styles };
